import { css } from '@lastbrand/web-ui-styled-system/css'

// Brand/title/rating styling now lives in the ProductNameDS block (Figma node 8306:145026);
// this file keeps only the container, the header row that pairs the name block with the
// wishlist icon, and the legacy brand style still imported by mini-pdp-product-info-ds.

export const containerCss = css({
  // `full`, not `inherit`: the standalone-PDP host sizes the buy box `calc(100% - 32px)` on mobile,
  // and `inherit` copies that literal calc() to re-resolve against the already-inset box — the
  // title/price block rendered 32px narrower than the column (STRFRNT-16782).
  width: 'full',
})

// The margin variants below are mutually exclusive (picked in product-info-ds.tsx);
// stacking them as overrides is unreliable because Panda emits one class per
// property value and their stylesheet order is not the cx() order.
export const containerSpacingCss = css({
  mb: 'space-20',
})

export const containerUpdatedDesignV2Css = css({
  mb: 'space-24',
})

export const containerThirdPartyCss = css({
  mb: 'space-20',
})

export const containerNewDesignV2BundleCss = css({
  mb: 0,
})

// Still imported by mini-pdp-product-info-ds.tsx — do not remove with the parity markup.
export const containerBrandNameCss = css({
  textStyle: 'body-12',
  lineHeight: '18px', // legacy 1.8rem
  fontWeight: 500,
  letterSpacing: '1.5px',
  textTransform: 'uppercase',
  color: 'mediumgray',
  mb: { base: 'space-10', lg: 'space-4' },
  borderBottom: '1px solid transparent',
  display: 'inline-block',
  _hover: {
    color: 'black',
    borderBottom: '1px solid token(colors.black)',
  },
})

// Header row = ProductNameDS + wishlist icon. The name block no longer varies on
// updatedDesignForV2 — the Figma ProductName design is the single truth. The pb owns
// the gap to the price block (previously the review summary's mb).
export const containerHeaderCss = css({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 'space-24',
  width: 'full',
  pb: 'space-20',
})

export const productNameCss = css({
  flex: '1 1 auto',
  minWidth: 0,
})

export const containerHeaderIconCss = css({
  marginTop: 'space-4',
  cursor: 'pointer',
  display: { base: 'none', lg: 'block' },
})
